<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: "app",
  components: {},
  created() {

  },
  mounted() {

  },
  data() {
    return {
      showMe: true
    };
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    }
  },
  created() {
    this.checkMobile();
    // this.initREM()
    //   var VConsole = require('vconsole');
    //   var vConsole = new VConsole();
  },
  mounted() {
    document.getElementById("first-loading").style.display = "none";
  },
  methods: {
    checkMobile: function() {
      let isMobile = false;
      let browser = {
        versions: (function() {
          let u = navigator.userAgent,
            app = navigator.appVersion;
          return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1, //
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") === -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1 //是否微信
          };
        })(),
        language: (navigator.browserLanguage || navigator.language
        ).toLowerCase()
      };
      if (
        browser.versions.mobile ||
        browser.versions.ios ||
        browser.versions.android ||
        browser.versions.iPhone ||
        browser.versions.iPad
      ) {
        isMobile = true;
        // this.$store.dispatch("toggleSide");
      }
      this.$store.dispatch("setIsMobile", isMobile);
    },
    initREM() {
      const win = window;
      /**
             * @param {Number} [baseFontSize = 100] - 基础fontSize, 默认100px;
             * @param {Number} [fontscale = 1] - 有的业务希望能放大一定比例的字体;
             */
      let flex = function(baseFontSize, fontscale) {
        const _baseFontSize = baseFontSize || 100;
        const _fontscale = fontscale || 2;
        const doc = win.document;
        const ua = navigator.userAgent;
        const matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
        const UCversion = ua.match(/U3\/((\d+|\.){5,})/i);
        const isUCHd =
          UCversion && parseInt(UCversion[1].split(".").join(""), 10) >= 80;
        const isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
        let dpr = win.devicePixelRatio || 1;
        if (!isIos && !(matches && matches[1] > 534) && !isUCHd) {
          // 如果非iOS, 非Android4.3以上, 非UC内核, 就不执行高清, dpr设为1;
          dpr = 1;
        }
        const scale = 1 / dpr;
        let metaEl = doc.querySelector('meta[name="viewport"]');
        if (!metaEl) {
          metaEl = doc.createElement("meta");
          metaEl.setAttribute("name", "viewport");
          doc.head.appendChild(metaEl);
        }
        metaEl.setAttribute(
          "content",
          `width=device-width,user-scalable=no,initial-scale=${scale},maximum-scale=${scale},minimum-scale=${scale}`
        );
        doc.documentElement.style.fontSize = `${_baseFontSize /
          2 *
          dpr *
          _fontscale}px`;
        console.log(doc.documentElement.style.fontSize);
      };
      flex(100, 1);
    }
  }
};
</script>

<style>
#app {
  /* background: #fff */
}
body {
  overflow: visible!important;
}

.css-shadow-right {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 0 6px 0 rgba(0, 0, 0, 0.1);
}


</style>



// WEBPACK FOOTER //
// App.vue?e27a7876